/* =============================================================================
 * MEDICION POR RUTA · convierte los cambios de ruta de la SPA en visitas reales.
 * -----------------------------------------------------------------------------
 * Sin esto Meta veria UNA visita por sesion. `fbevents.js` cuenta paginas por
 * carga de documento, y aqui las seis paginas comparten la misma carga: quien
 * entre por el hub y recorra las cinco ciudades apareceria como alguien que miro
 * una sola pagina y se fue.
 *
 * NO PINTA NADA. Es hermano de `ScrollToTop`: vive en el `RootLayout` y su
 * trabajo entero son efectos.
 * ========================================================================== */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteSeo } from '@/features/seo';
import { captureCampaign } from './campaign';
import { onConsentChange, readConsent, type ConsentState } from './consent';
import { enablePixel, trackPageView, trackViewContent } from './pixel';

export function RouteTracking() {
  const { pathname, search } = useLocation();
  const [consent, setConsent] = useState<ConsentState>(readConsent);

  /* LA CAMPAÑA SE CAPTURA ANTES QUE NADA Y AL MARGEN DEL CONSENTIMIENTO, porque
   * los `utm_*` viven SÓLO en la URL de aterrizaje: en cuanto el visitante pulsa
   * un enlace interno, React Router los borra de la barra y ya no vuelven. Si se
   * esperara a que conteste el banner, quien navegue antes de contestar llega al
   * botón de entradas sin campaña y la venta no se puede atribuir.
   * Los identificadores de clic (`fbclid`, `gclid`) SÍ esperan al sí: ver
   * `campaign.ts`, que separa las dos listas y explica por qué. */
  useEffect(() => {
    captureCampaign(search, consent === 'granted');
  }, [search, consent]);

  // El banner no llama a este componente: escribe el consentimiento y este se
  // entera. Asi la puerta es UNA (el modulo `consent`) y no hay forma de
  // encender el pixel por un camino que no pase por ella.
  useEffect(() => onConsentChange(setConsent), []);

  useEffect(() => {
    if (consent !== 'granted') return;

    // `enablePixel` ya manda el PageView de la vista en la que arranca. Si
    // devuelve `false` es que venia arrancado, y entonces es ESTE cambio de ruta
    // el que necesita el suyo. Mandar los dos contaria la pagina dos veces.
    //
    // (En `dev` React 19 invoca los efectos dos veces por `StrictMode`, asi que
    // ahi se ve un PageView de mas. En el build de produccion no ocurre: no se
    // «arregla» rompiendo el modo estricto, que esta para lo que esta.)
    if (!enablePixel()) trackPageView();

    const route = getRouteSeo(pathname);
    if (route?.event) {
      trackViewContent({
        id: route.event.slug,
        name: `${route.event.city} · ${route.event.title}`,
      });
    }
  }, [consent, pathname]);

  return null;
}
